import Text, { TextProps } from "../Text";

const TextCaption = (props: TextProps) => {
  return <Text {...props} fontSize={12} />;
};

export default TextCaption;
